//
import { mapActions } from "vuex"
import { ModelForm } from "@/components/reusable_components/next"
import TranslatorService from "@/services/translator"

//
import PurchaseQuotationModel from "@/models/Purchase/PchPurchaseQuotation"
import fields from "./fields"

//
export default {
    name: "purchase-quotation-update",
    components: {
        ModelForm,
    },
    computed: {

        /**
         * @description
         */
        formProps () {
            return {
                editable: false,
                fields,
                loading: this.formBusy,
                switchEdit: true,
            }
        },
    },
    data () {
        return {
            formBusy: false,
            formData: {},
        }
    },
    methods: {
        
        /**
         * @description
         */
        ...mapActions( "MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
        }),

        /**
         * @description
         */
        ...mapActions( "SnackbarModalModule", {
            setErrorSnackbar: "setErrorSnackbar",
            setSuccessSnackbar: "setSuccessSnackbar",
        }),

        /**
         * @description
         * 
         */
        error ( error ) {
            this.setErrorSnackbar( TranslatorService( PurchaseQuotationModel, error.response.data ) )
        },

        /**
         * @description
         * 
         */
        redirect () {
            this.$router.push({ name: "purchase-quotation-list" })
        },

        /**
         * @description
         * 
         */
        reset () {
            this.formBusy = true
            PurchaseQuotationModel.modeler().find( this.$route.params.id ).then( this.setFormData )
        },
        
        /**
         * @description
         * 
         */
        setFormData ( model ) {
            this.formData = model.reset()
            this.formBusy = false
        },
        
        /**
         * @description
         * 
         */
        submit () {
            this.$refs.form.setWait( true ).then( this.update )
        },

        /**
         * @description
         * 
         */
        success () {
            this.setSuccessSnackbar( "Cotización de compra actualizada." )
        },

        /**
         * @description
         * 
         */
        update ( model ) {
            model.toUpdate().save().finally( this.$refs.form.setWait ).then( this.success ).then( this.redirect ).catch( this.error )
        },
    },
    beforeMount () {
        this.setTitleTopBar( "Datos de cotización de compra" )
    },
    mounted (){
        this.reset()
    }
}